import { useState, useEffect, useReducer, useRef } from "react";
import NextFront_Favicon from "./Next_Front_Favicon.png";
import Duplex_terrace_view from "./images/Duplex_terrace_view.jpeg";
// import Town_squree from "./images/Town_squree.png";
import Belmont from "./images/Belmont.png";
import emailjs from "@emailjs/browser";

const initialState = {
  activeTab: "BUY",
  selectedType: "",
  selectedBeds: [],
  searchQuery: "",
  wishlist: [],
  activeFilter: "ALL",
  contactStep: 1,
  contactInterest: "",
  contactBeds: "",
  menuOpen: false,
  heroSlide: 0,
  selectedProperty: null,
  showPaymentPlan: false,
  selectedService: null,
  showServiceModal: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_TAB":
      return { ...state, activeTab: action.payload };
    case "SET_TYPE":
      return { ...state, selectedType: action.payload };
    case "TOGGLE_BED": {
      const beds = state.selectedBeds.includes(action.payload)
        ? state.selectedBeds.filter((b) => b !== action.payload)
        : [...state.selectedBeds, action.payload];
      return { ...state, selectedBeds: beds };
    }
    case "TOGGLE_WISHLIST": {
      const list = state.wishlist.includes(action.payload)
        ? state.wishlist.filter((i) => i !== action.payload)
        : [...state.wishlist, action.payload];
      return { ...state, wishlist: list };
    }
    case "SET_FILTER":
      return { ...state, activeFilter: action.payload };
    case "SET_CONTACT_STEP":
      return { ...state, contactStep: action.payload };
    case "SET_CONTACT_INTEREST":
      return { ...state, contactInterest: action.payload };
    case "SET_CONTACT_BEDS":
      return { ...state, contactBeds: action.payload };
    case "SET_MENU":
      return { ...state, menuOpen: action.payload };
    case "SET_HERO_SLIDE":
      return { ...state, heroSlide: action.payload };
    case "SET_SEARCH":
      return { ...state, searchQuery: action.payload };
    case "SET_SELECTED_PROPERTY":
      return { ...state, selectedProperty: action.payload };
    case "SET_SHOW_PAYMENT_PLAN":
      return { ...state, showPaymentPlan: action.payload };
    case "SET_SELECTED_SERVICE":
      return { ...state, selectedService: action.payload };
    case "SET_SHOW_SERVICE_MODAL":
      return { ...state, showServiceModal: action.payload };
    default:
      return state;
  }
}

const HERO_SLIDES = [
  {
    title: "WHERE LUXURY MEETS",
    highlight: "EXCELLENCE IN DUBAI",
    sub: "Burj Khalifa & Downtown",
    loc: "Downtown Dubai",
    image: "https://casabella.ae/wp-content/uploads/2024/10/Dubai-Real-estate-q3.webp",
  },
  {
    title: "DISCOVER YOUR",
    highlight: "DREAM HOME IN DUBAI",
    sub: "Dubai Marina Waterfront",
    loc: "Dubai Marina",
    image: "https://img-v2.gtsstatic.net/reno/imagereader.aspx?url=https%3A%2F%2Fm.sothebysrealty.com%2F1259i215%2F915atnh66bbrmmadbyk7gx98t4i215&w=3840&q=75&option=N&permitphotoenlargement=false&fallbackimageurl=https%3A%2F%2Fwww.sothebysrealty.com%2Fassets%2Fimages%2Fcommon%2Fnophoto%2Flisting.jpg",
  },
  {
    title: "REDEFINING",
    highlight: "LUXURY LIVING",
    sub: "Palm Jumeirah Residences",
    loc: "Palm Jumeirah",
    image: "https://www.forbesglobalproperties.com/wp-content/uploads/2025/04/bCFeGmy7DSkm5rB1F8pxt4Peq9JnxGxOUUY4gi4O-1083491-1745460230.jpg",
  },
  {
    title: "NEW LAUNCH",
    highlight: "BELMONT ON THE PARK",
    sub: "Town Square Dubai",
    loc: "by Nshama",
    image: Belmont,
  },
];

const PROPERTIES = [
  {
    id: 1,
    name: "The Ritz Carlton Residences",
    area: "Business Bay",
    type: "Apartment",
    beds: "1–6",
    baths: 5,
    sqft: "1,436",
    price: "AED 16,298,570",
    tag: "LUXURY",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 2,
    name: "Six Senses Residences",
    area: "Dubai Marina",
    type: "Penthouse",
    beds: "2–5",
    baths: 6,
    sqft: "14,102",
    price: "AED 5,800,000",
    tag: "LUXURY",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 3,
    name: "Mercedes Benz Places",
    area: "Downtown Dubai",
    type: "Penthouse",
    beds: "2–5",
    baths: 5,
    sqft: "14,130",
    price: "AED 8,800,000",
    tag: "LUXURY",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 4,
    name: "Address Hillcrest",
    area: "Dubai Hills Estate",
    type: "Villa",
    beds: "5",
    baths: 6,
    sqft: "7,128",
    price: "AED 25,000,000",
    tag: "FEATURED",
    badge: "EXCLUSIVE",
    image: "https://images.unsplash.com/photo-1613977257363-707ba9348227?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 5,
    name: "District One Villas",
    area: "MBR City",
    type: "Villa",
    beds: "4",
    baths: 6,
    sqft: "6,134",
    price: "AED 14,999,999",
    tag: "FEATURED",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?q=80&w=2071&auto=format&fit=crop",
  },
  {
    id: 6,
    name: "Burj Crown",
    area: "Downtown Dubai",
    type: "Apartment",
    beds: "3",
    baths: 3,
    sqft: "1,356",
    price: "AED 4,400,000",
    tag: "FEATURED",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 7,
    name: "La Mer South Island",
    area: "Jumeirah",
    type: "Villa",
    beds: "5",
    baths: 7,
    sqft: "7,485",
    price: "AED 1,997,000/yr",
    tag: "RENT",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?q=80&w=2025&auto=format&fit=crop",
  },
  {
    id: 8,
    name: "Aura Gardens",
    area: "Tilal Al Ghaf",
    type: "Townhouse",
    beds: "5",
    baths: 6,
    sqft: "3,411",
    price: "AED 340,000/yr",
    tag: "RENT",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 9,
    name: "The Acres",
    area: "Dubailand",
    type: "Villa",
    beds: "3–4",
    baths: 4,
    sqft: "6,001",
    price: "AED 5,090,000",
    tag: "OFF-PLAN",
    badge: "OFF-PLAN",
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 10,
    name: "Vela Viento",
    area: "Marasi Bay",
    type: "Apartment",
    beds: "2–4",
    baths: 4,
    sqft: "14,413",
    price: "AED 19,000,000",
    tag: "LUXURY",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?q=80&w=2074&auto=format&fit=crop",
  },
  {
    id: 11,
    name: "Jumeirah Gate Tower 2",
    area: "JBR",
    type: "Apartment",
    beds: "2",
    baths: 2,
    sqft: "1,168",
    price: "AED 7,800,000",
    tag: "FEATURED",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 12,
    name: "Creek Gate Tower 2",
    area: "Dubai Creek Harbour",
    type: "Apartment",
    beds: "2",
    baths: 2,
    sqft: "1,045",
    price: "AED 200,000/yr",
    tag: "RENT",
    badge: "VERIFIED",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=2080&auto=format&fit=crop",
  },
  {
    id: 13,
    name: "Belmont on the Park",
    area: "Town Square",
    type: "Apartment",
    beds: "1–3",
    baths: "2-3",
    sqft: "655-1415",
    price: "AED 1,200,888",
    tag: "OFF-PLAN",
    badge: "NEW LAUNCH",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=2070&auto=format&fit=crop",
    isNewLaunch: true,
    developer: "Nshama",
    community: "Town Square",
    startingPrices: {
      "1 Bedroom": "AED 1,200,888",
      "2 Bedroom": "AED 1,680,888",
      "3 Bedroom": "AED 2,708,888",
    },
    sizes: {
      "1 Bedroom": "655 sq.ft",
      "2 Bedroom": "962 - 1338 sq.ft",
      "3 Bedroom": "1415 sq.ft",
    },
    features: [
      "Fully fitted kitchens with premium white goods",
      "Elegant, thoughtfully designed interiors",
      "Park-facing lifestyle",
      "Town Square community",
    ],
    paymentPlan: {
      type: "40/60",
      handover: "April 2029",
      installments: [
        { phase: "1st Installment", percent: "5%", date: "Feb 2026" },
        { phase: "2nd Installment", percent: "5%", date: "Apr 2026" },
        { phase: "3rd Installment", percent: "5%", date: "Aug 2026" },
        { phase: "4th Installment", percent: "5%", date: "Dec 2026" },
        { phase: "5th Installment", percent: "5%", date: "June 2027" },
        { phase: "6th Installment", percent: "5%", date: "Dec 2027" },
        { phase: "7th Installment", percent: "5%", date: "May 2028" },
        { phase: "8th Installment", percent: "5%", date: "Oct 2028" },
        { phase: "Handover", percent: "60%", date: "Apr 2029 *Indicative" },
      ],
    },
    eoi: "AED 20,000",
    status: "Unit allocation ongoing",
    release: "Prices & full details to be officially released soon",
    googleMapsLink: "https://maps.app.goo.gl/w6XbFvs7Sr7L4Qtw7?g_st=ipc",
  },
];

const NEIGHBORHOODS = [
  { name: "Palm Jumeirah", count: "142 Properties", image: Duplex_terrace_view, tall: true },
  { name: "Downtown Dubai", count: "98 Properties", image: "https://images.unsplash.com/photo-1526495124232-a04e1849168c?auto=format&fit=crop&w=2000&q=80" },
  { name: "Dubai Marina", count: "87 Properties", image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=2000&q=80" },
  { name: "Business Bay", count: "73 Properties", image: "https://images.unsplash.com/photo-1580674684081-7617fbf3d745?auto=format&fit=crop&w=2000&q=80" },
];

const SERVICES = [
  {
    icon: "🏠",
    title: "Sales",
    desc: "Finding your dream home in Dubai, guiding you all the way through the process with expertise and care.",
    features: ["Expert Property Valuation", "Market Analysis & Insights", "Negotiation Expertise", "Legal Documentation Support", "Post-Sale Assistance", "Mortgage Advisory"],
  },
  {
    icon: "🔑",
    title: "Property Management",
    desc: "We handle property care, tenant satisfaction, and more, ensuring your investment thrives over time.",
    features: ["Tenant Screening & Placement", "Rent Collection & Accounting", "Maintenance & Repairs", "Regular Property Inspections", "24/7 Emergency Support", "Legal Compliance"],
  },
  {
    icon: "📈",
    title: "Investment Portfolio",
    desc: "Get expert guidance to build and manage your property portfolio, optimizing returns for the long term.",
    features: ["Portfolio Strategy Development", "Risk Assessment & Management", "ROI Optimization", "Market Trend Analysis", "Diversification Guidance", "Exit Strategy Planning"],
  },
  {
    icon: "✏️",
    title: "Design & Build",
    desc: "Transform your luxury home effortlessly with our specialist team of world-class designers.",
    features: ["Interior Design Consultation", "Architectural Planning", "Project Management", "Material Selection", "Turnkey Solutions", "Luxury Finishes"],
  },
  {
    icon: "🏗️",
    title: "New Launch - Belmont on the Park",
    desc: "Nshama proudly introduces BELMONT on the Park at Town Square",
    isNewLaunch: true,
    property: PROPERTIES.find((p) => p.id === 13),
  },
];

const TESTIMONIALS = [
  { name: "Mr. Geradus A.", avatar: "GA", rating: 5, text: "Outstanding agency to work with. Skilled listeners and negotiators with very in-depth knowledge of the Dubai real estate market. Truly exceptional professionals." },
  { name: "Mr. Mark E.", avatar: "ME", rating: 5, text: "Amazing experience with Prime Estates. Their professionalism, knowledge, and patience were outstanding throughout the entire buying process. Highly recommended." },
  { name: "Mr. Hamid C.", avatar: "HC", rating: 5, text: "Very professional and kind with valuable advice. After an amazing experience as an investor, a natural choice for property management in Dubai." },
];

const S = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300&family=Montserrat:wght@300;400;500;600;700;800&display=swap');
*,*::before,*::after{margin:0;padding:0;box-sizing:border-box;}
:root{
  --g:#C4913A;--gl:#E8C07D;--gd:#9A6F25;
  --k:#080808;--d1:#0E0E0E;--d2:#161616;--d3:#1E1E1E;--d4:#272727;
  --b:#2E2E2E;--t:#F0EDE8;--dm:#A8A5A0;--ft:#565250;--w:#FAFAF8;
}
html{scroll-behavior:smooth;scroll-padding-top:70px;}
body{background:var(--k);color:var(--t);font-family:'Montserrat',sans-serif;overflow-x:hidden;}
button{font-family:'Montserrat',sans-serif;}

/* NAV */
.nav{position:fixed;top:0;left:0;right:0;z-index:1000;padding:0 56px;display:flex;align-items:center;justify-content:space-between;height:78px;transition:background .4s,border-color .4s;border-bottom:1px solid transparent;}
.nav.sc{background:rgba(8,8,8,.97);border-bottom-color:var(--b);}
.logo{font-family:'KyivType Sans Black',serif;font-size:35px;font-weight:600;color:var(--w);letter-spacing:3px;cursor:pointer;display:flex;align-items:center;gap:10px;}
.logo em{color:var(--g);font-style:normal;}
.nav-favicon{width:65px;height:65px;border-radius:50%;object-fit:cover;}
.nl{display:flex;align-items:center;gap:34px;}
.nl a{font-size:10px;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;color:var(--dm);cursor:pointer;transition:color .2s;background:none;border:none;padding-bottom:3px;position:relative;}
.nl a::after{content:'';position:absolute;bottom:0;left:0;width:0;height:1px;background:var(--g);transition:width .3s;}
.nl a:hover{color:var(--w);}
.nl a:hover::after{width:100%;}
.ncta{font-size:10px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:var(--k);background:var(--g);border:none;cursor:pointer;padding:11px 24px;transition:all .2s;}
.ncta:hover{background:var(--gl);transform:translateY(-1px);}
.mb{display:none;background:none;border:none;cursor:pointer;flex-direction:column;gap:5px;padding:10px;}
.mb span{display:block;width:22px;height:2px;background:var(--t);transition:all 0.3s ease;}

/* MOBILE MENU */
.mm{position:fixed;inset:0;background:rgba(8,8,8,.98);z-index:1002;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:28px;opacity:0;pointer-events:none;transition:opacity .3s;backdrop-filter:blur(10px);}
.mm.open{opacity:1;pointer-events:all;}
.mc{position:absolute;top:26px;right:30px;font-size:24px;color:var(--dm);cursor:pointer;background:none;border:none;}
.ml{font-family:'KyivType Sans Black',serif;font-size:38px;font-weight:300;color:var(--dm);cursor:pointer;background:none;border:none;letter-spacing:2px;transition:color .2s;}
.ml:hover{color:var(--g);}

/* HERO - REDUCED TEXT SIZE AND PADDING */
.hero{position:relative;height:100vh;overflow:hidden;display:flex;align-items:flex-end;}
.hslide{position:absolute;inset:0;opacity:0;transition:opacity 1.4s ease;}
.hslide.on{opacity:1;}
.hc{position:relative;z-index:2;padding:20px 80px 180px;max-width:940px;}
.hey{font-size:10px;font-weight:700;letter-spacing:5px;color:var(--g);text-transform:uppercase;margin-bottom:18px;display:flex;align-items:center;gap:14px;}
.hey::before{content:'';display:block;width:34px;height:1px;background:var(--g);}
.ht1{font-family:'KyivType Sans Black',serif;font-size:clamp(32px,4.5vw,66px);font-weight:300;line-height:1.05;color:var(--w);letter-spacing:-1px;}
.ht2{font-family:'KyivType Sans Black',serif;font-size:clamp(32px,4.5vw,66px);font-weight:700;line-height:1.05;color:var(--g);letter-spacing:-1px;}
.hprop{margin-top:26px;}
.hpn{font-family:'KyivType Sans Black',serif;font-size:18px;font-weight:500;color:var(--w);}
.hpl{font-size:10px;font-weight:600;letter-spacing:2px;color:var(--dm);text-transform:uppercase;margin-top:4px;display:flex;align-items:center;gap:8px;}
.hpl::before{content:'';display:block;width:16px;height:1px;background:var(--dm);}
.hbtns{display:flex;gap:14px;margin-top:34px;flex-wrap:wrap;}
.bg{font-size:14px;font-weight:800;letter-spacing:2.5px;text-transform:uppercase;background:var(--g);color:var(--k);border:none;cursor:pointer;padding:15px 40px;transition:all .25s;min-height:44px;}
.bg:hover{background:var(--gl);transform:translateY(-2px);box-shadow:0 12px 36px rgba(196,145,58,.28);}
.bo{font-size:16px;font-weight:800;letter-spacing:2.5px;text-transform:uppercase;background:transparent;color:var(--w);border:1px solid rgba(255,255,255,.3);cursor:pointer;padding:15px 40px;transition:all .25s;min-height:44px;}
.bo:hover{border-color:var(--g);color:var(--g);}
.hdots{position:absolute;right:54px;top:50%;transform:translateY(-50%);z-index:10;display:flex;flex-direction:column;gap:9px;}
.hdot{width:2px;height:18px;background:rgba(255,255,255,.22);cursor:pointer;border:none;transition:all .3s;}
.hdot.on{height:40px;background:var(--g);}
.hscrl{position:absolute;bottom:38px;right:70px;z-index:10;font-size:9px;font-weight:700;letter-spacing:3px;color:rgba(255,255,255,.3);text-transform:uppercase;writing-mode:vertical-rl;display:flex;align-items:center;gap:12px;}
.hscrl::after{content:'';width:1px;height:52px;background:var(--gd);animation:sp 2.2s infinite;}
@keyframes sp{0%,100%{opacity:.3;}50%{opacity:1;}}

/* TICKER */
.tkw{overflow:hidden;padding:17px 0;background:var(--g);}
.tk{display:flex;gap:52px;white-space:nowrap;animation:tck 22s linear infinite;}
@keyframes tck{from{transform:translateX(0);}to{transform:translateX(-50%);}}
.tki{font-size:10px;font-weight:800;letter-spacing:4px;color:var(--k);text-transform:uppercase;display:flex;align-items:center;gap:16px;}
.tki::before{content:'✦';font-size:8px;}

/* SECTIONS */
.sec{padding:96px 80px;}
.si{max-width:1400px;margin:0 auto;}
.ey{font-size:10px;font-weight:700;letter-spacing:5px;color:var(--g);text-transform:uppercase;margin-bottom:15px;display:flex;align-items:center;gap:14px;}
.ey::before{content:'';display:block;width:26px;height:1px;background:var(--g);}
.stit{font-family:'KyivType Sans Black',serif;font-size:clamp(32px,3.8vw,54px);font-weight:400;color:var(--w);line-height:1.1;margin-bottom:16px;}
.stit strong{font-weight:700;color:var(--g);}
.sdesc{font-size:14px;line-height:1.9;color:var(--dm);max-width:560px;}

/* ABOUT */
.absec{background:var(--d2);}
.agrid{display:grid;grid-template-columns:1fr 1fr;gap:80px;align-items:center;}
.aiw{position:relative;height:560px;}
.aac{position:absolute;bottom:-22px;right:-22px;width:180px;height:180px;border:1px solid var(--g);opacity:.4;pointer-events:none;}
.abd{position:absolute;top:26px;left:-26px;background:var(--g);color:var(--k);padding:18px 22px;text-align:center;z-index:2;}
.abn{font-family:'KyivType Sans Black',serif;font-size:42px;font-weight:700;line-height:1;}
.abt{font-size:9px;font-weight:700;letter-spacing:2px;text-transform:uppercase;}

/* NEIGHBORHOODS */
.nbsec{background:var(--d1);padding:96px 80px;}
.nbgrid{display:grid;grid-template-columns:2fr 1fr 1fr;grid-template-rows:280px 280px;gap:3px;margin-top:52px;}
.nbcard{position:relative;overflow:hidden;cursor:pointer;-webkit-tap-highlight-color:transparent;}
.nbcard:first-child{grid-row:span 2;}
.nbover{position:absolute;inset:0;background:linear-gradient(180deg,transparent 40%,rgba(0,0,0,.75) 100%);transition:background .3s;}
.nbcard:hover .nbover{background:linear-gradient(180deg,transparent 20%,rgba(0,0,0,.85) 100%);}
.nbcard:hover .nbbg-inner{transform:scale(1.07);}
.nbbg-inner{width:100%;height:100%;transition:transform .7s ease;}
.nbbg-inner img{width:100%;height:100%;object-fit:cover;}
.nbinfo{position:absolute;bottom:0;left:0;right:0;padding:22px;}
.nbname{font-family:'KyivType Sans Black',serif;font-size:22px;font-weight:600;color:var(--w);margin-bottom:4px;}
.nbcount{font-size:10px;font-weight:700;letter-spacing:2px;color:var(--g);text-transform:uppercase;}

/* PROPS */
.fb{display:flex;gap:4px;flex-wrap:wrap;margin-bottom:42px;}
.fb button{font-size:10px;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;padding:10px 22px;border:1px solid var(--b);background:none;color:var(--ft);cursor:pointer;transition:all .2s;}
.fb button.on{background:var(--g);color:var(--k);border-color:var(--g);}
.fb button:hover:not(.on){border-color:var(--dm);color:var(--dm);}
.pg{display:grid;grid-template-columns:repeat(3,1fr);gap:3px;}
.pc{position:relative;overflow:hidden;cursor:pointer;background:var(--d2);-webkit-tap-highlight-color:transparent;}
.pc:hover .pover{opacity:1;}
.pc:hover .pcbg{transform:scale(1.06);}
.piw{position:relative;overflow:hidden;aspect-ratio:16/10;}
.pcbg{width:100%;height:100%;transition:transform .7s ease;}
.pcbg img{width:100%;height:100%;object-fit:cover;}
.pbadge{position:absolute;top:13px;left:13px;background:var(--g);color:var(--k);font-size:8px;font-weight:800;letter-spacing:2px;padding:4px 10px;text-transform:uppercase;z-index:2;}
.pbadge.op{background:transparent;border:1px solid var(--g);color:var(--g);}
.pbadge.new-launch{background:linear-gradient(135deg,#FF6B6B,#FF8E53);color:white;border:none;}
.pheart{position:absolute;top:11px;right:11px;background:rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.15);border-radius:50%;width:34px;height:34px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:13px;transition:all .2s;z-index:2;}
.pheart.lk{background:rgba(220,38,38,.2);border-color:rgba(220,38,38,.4);}
.pover{position:absolute;inset:0;background:rgba(0,0,0,.42);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s;z-index:3;}
.pinfo{padding:20px;background:var(--d2);border-top:1px solid var(--b);}
.pty{font-size:9px;font-weight:700;letter-spacing:2px;color:var(--g);text-transform:uppercase;margin-bottom:5px;}
.pnm{font-family:'KyivType Sans Black',serif;font-size:20px;font-weight:600;color:var(--w);margin-bottom:4px;}
.par{font-size:11px;font-weight:500;color:var(--dm);margin-bottom:10px;display:flex;align-items:center;gap:5px;}
.pmeta{display:flex;gap:14px;color:var(--ft);font-size:11px;font-weight:500;margin-bottom:12px;flex-wrap:wrap;}
.ppr{font-family:'KyivType Sans Black',serif;font-size:20px;font-weight:600;color:var(--g);}
.developer-badge{display:inline-block;background:rgba(196,145,58,0.1);color:var(--g);font-size:10px;padding:4px 8px;border-radius:2px;margin-bottom:8px;}
.eoi-badge{display:inline-block;background:transparent;border:1px dashed var(--g);color:var(--g);font-size:10px;padding:4px 8px;border-radius:2px;margin-left:8px;}
.emp{text-align:center;padding:80px;color:var(--ft);}

/* LUXURY BANNER */
.lxb{position:relative;height:500px;overflow:hidden;display:flex;align-items:center;justify-content:center;}
.lxbg{position:absolute;inset:0;transition:transform 8s ease;}
.lxb:hover .lxbg{transform:scale(1.04);}
.lxbg img{width:100%;height:100%;object-fit:cover;}
.lxbov{position:absolute;inset:0;background:linear-gradient(135deg,rgba(8,8,8,.85) 0%,rgba(8,8,8,.5) 50%,rgba(8,8,8,.85) 100%);}
.lxcont{position:relative;z-index:2;text-align:center;padding:0 40px;}
.lxtag{font-size:10px;font-weight:700;letter-spacing:5px;color:var(--g);text-transform:uppercase;margin-bottom:20px;}
.lxtit{font-family:'KyivType Sans Black',serif;font-size:clamp(36px,5vw,64px);font-weight:300;color:var(--w);line-height:1.1;margin-bottom:8px;}
.lxtit strong{font-weight:700;color:var(--g);}
.lxsub{font-size:14px;color:var(--dm);margin-bottom:36px;letter-spacing:1px;}
.lxbtns{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}

/* SERVICES */
.svcsec{background:var(--d1);}
.svgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:1px;margin-top:52px;}
.svcard{background:var(--d2);padding:42px 30px;border-top:2px solid transparent;transition:all .3s;}
.svcard:hover{background:var(--d3);border-top-color:var(--g);}
.svico{font-size:28px;margin-bottom:17px;}
.svt{font-family:'KyivType Sans Black',serif;font-size:22px;font-weight:600;color:var(--w);margin-bottom:12px;}
.svd{font-size:13px;line-height:1.8;color:var(--ft);}
.svl{display:inline-flex;align-items:center;gap:8px;margin-top:16px;font-size:10px;font-weight:700;letter-spacing:2px;color:var(--g);text-transform:uppercase;cursor:pointer;border:none;background:none;transition:gap .2s;}
.svl:hover{gap:14px;}

/* WHY */
.whysec{background:var(--d2);}
.wgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:2px;margin-top:54px;}
.wcard{background:var(--d3);padding:46px 34px;border-bottom:2px solid transparent;transition:all .35s;}
.wcard:hover{border-bottom-color:var(--g);transform:translateY(-4px);}
.wico{font-size:32px;margin-bottom:18px;}
.wt{font-family:'KyivType Sans Black',serif;font-size:22px;font-weight:600;color:var(--w);margin-bottom:12px;}
.wd{font-size:13px;line-height:1.8;color:var(--ft);}

/* CONTACT */
.ctrsec{background:var(--d1);position:relative;overflow:hidden;}
.ctrsec::before{content:'';position:absolute;top:-180px;right:-180px;width:580px;height:580px;background:radial-gradient(circle,rgba(196,145,58,.07) 0%,transparent 70%);pointer-events:none;}
.cgrid{display:grid;grid-template-columns:1fr 1fr;gap:92px;align-items:start;}
.cform{background:var(--d3);border:1px solid var(--b);padding:46px;}
.cft{font-family:'KyivType Sans Black',serif;font-size:28px;font-weight:600;color:var(--w);margin-bottom:6px;}
.cfs{font-size:11px;color:var(--ft);margin-bottom:26px;letter-spacing:1px;}
.csteps{display:flex;gap:6px;margin-bottom:26px;}
.csd{width:30px;height:2px;background:var(--b);transition:background .3s;}
.csd.on{background:var(--g);}
.igrid{display:grid;grid-template-columns:1fr 1fr;gap:11px;margin-bottom:20px;}
.ib{padding:17px;border:1px solid var(--b);background:none;cursor:pointer;text-align:left;transition:all .25s;color:var(--dm);}
.ib.on{border-color:var(--g);background:rgba(196,145,58,.06);}
.ib:hover:not(.on){border-color:var(--d4);}
.ii{font-size:20px;margin-bottom:7px;display:block;}
.il{font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;}
.fi{width:100%;padding:13px 15px;background:var(--d2);border:1px solid var(--b);color:var(--t);font-family:'Montserrat',sans-serif;font-size:13px;outline:none;transition:border-color .2s;margin-bottom:9px;}
.fi:focus{border-color:var(--g);}
.fi::placeholder{color:var(--ft);}
.frow{display:grid;grid-template-columns:1fr 1fr;gap:9px;}
.fbk{font-size:10px;font-weight:700;letter-spacing:2px;color:var(--ft);text-transform:uppercase;cursor:pointer;background:none;border:none;transition:color .2s;min-height:44px;}
.fbk:hover{color:var(--dm);}
.fnx{font-size:10px;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;background:var(--g);color:var(--k);border:none;cursor:pointer;padding:13px 32px;transition:all .2s;min-height:44px;}
.fnx:hover{background:var(--gl);}
.ci{display:flex;align-items:flex-start;gap:15px;margin-bottom:22px;}
.cii{width:44px;height:44px;min-width:44px;border:1px solid var(--b);display:flex;align-items:center;justify-content:center;font-size:16px;}
.cil{font-size:9px;font-weight:700;letter-spacing:2px;color:var(--g);text-transform:uppercase;margin-bottom:4px;}
.civ{font-size:13px;color:var(--dm);line-height:1.7;white-space:pre-line;}

/* TESTIMONIALS */
.tsec{background:var(--k);}
.tgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:2px;margin-top:52px;}
.tc{background:var(--d2);padding:38px;border-top:2px solid var(--b);transition:border-color .3s;}
.tc:hover{border-top-color:var(--g);}
.tst{color:var(--g);font-size:12px;margin-bottom:17px;letter-spacing:2px;}
.tt{font-size:14px;line-height:1.9;color:var(--dm);font-style:italic;margin-bottom:24px;}
.tau{display:flex;align-items:center;gap:13px;}
.tav{width:44px;height:44px;border-radius:50%;background:linear-gradient(135deg,var(--gd),var(--g));display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:var(--k);}
.tn{font-size:13px;font-weight:600;color:var(--w);}
.tr{font-size:10px;color:var(--ft);letter-spacing:1px;}

/* FOOTER */
.ftr{background:var(--d2);border-top:1px solid var(--b);padding:76px 80px;}
.fi2{max-width:1400px;margin:0 auto;}
.fg{display:grid;grid-template-columns:2fr 1fr 1fr 1.5fr;gap:54px;margin-bottom:52px;}
.fbn{font-family:'KyivType Sans Black',serif;font-size:26px;font-weight:600;color:var(--w);margin-bottom:3px;display:flex;align-items:center;gap:10px;}
.fbn em{color:var(--g);font-style:normal;}
.footer-favicon{width:40px;height:40px;border-radius:50%;object-fit:cover;border:1px solid var(--g);}
.ftg{font-size:10px;font-weight:600;letter-spacing:3px;color:var(--ft);text-transform:uppercase;margin-bottom:17px;}
.fdc{font-size:13px;line-height:1.8;color:var(--ft);margin-bottom:20px;}
.fsc{display:flex;gap:8px;}
.fsc button{width:36px;height:36px;background:var(--d4);border:1px solid var(--b);color:var(--dm);cursor:pointer;font-size:12px;transition:all .2s;}
.fsc button:hover{border-color:var(--g);color:var(--g);}
.fct{font-size:10px;font-weight:700;letter-spacing:3px;color:var(--g);text-transform:uppercase;margin-bottom:17px;}
.fl{display:block;font-size:13px;color:var(--ft);margin-bottom:9px;cursor:pointer;transition:color .2s;}
.fl:hover{color:var(--dm);}
.fbot{padding-top:26px;border-top:1px solid var(--b);display:flex;justify-content:space-between;align-items:center;font-size:11px;color:var(--ft);flex-wrap:wrap;gap:12px;}
.fbl{display:flex;gap:22px;}
.fbl span{cursor:pointer;transition:color .2s;}
.fbl span:hover{color:var(--dm);}
.orn{color:var(--g);font-weight:600;}

/* TOAST */
.tst2{position:fixed;bottom:30px;left:50%;transform:translateX(-50%);background:var(--d2);border:1px solid var(--g);color:var(--t);padding:13px 26px;font-size:12px;font-weight:600;letter-spacing:1px;z-index:9999;display:flex;align-items:center;gap:9px;animation:tin .3s ease;}
@keyframes tin{from{opacity:0;transform:translateX(-50%) translateY(8px);}to{opacity:1;transform:translateX(-50%) translateY(0);}}

/* PARTICLES */
@keyframes floatParticles{0%,100%{transform:translateY(0) translateX(0);opacity:0;}25%{opacity:0.3;}50%{transform:translateY(-20px) translateX(10px);opacity:0.6;}75%{opacity:0.3;}}
.particle{position:absolute;width:2px;height:2px;background:var(--g);border-radius:50%;opacity:0;animation:floatParticles 8s infinite;}

/* MODALS */
.modal-overlay,.payment-modal-overlay,.contact-modal-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.95);backdrop-filter:blur(10px);z-index:10000;display:flex;align-items:center;justify-content:center;opacity:0;pointer-events:none;transition:opacity 0.4s ease;}
.modal-overlay.active,.payment-modal-overlay.active,.contact-modal-overlay.active{opacity:1;pointer-events:all;}
.modal-content{background:var(--d2);border:1px solid var(--g);max-width:650px;width:90%;max-height:90vh;overflow-y:auto;padding:50px;position:relative;transform:scale(0.9);transition:transform 0.4s ease;box-shadow:0 30px 60px rgba(0,0,0,0.5);}
.modal-overlay.active .modal-content{transform:scale(1);}
.modal-close,.payment-modal-close,.contact-modal-close{position:absolute;top:15px;right:15px;background:none;border:none;color:var(--dm);font-size:28px;cursor:pointer;transition:color 0.2s;width:40px;height:40px;display:flex;align-items:center;justify-content:center;border-radius:50%;z-index:10;}
.modal-close:hover,.payment-modal-close:hover,.contact-modal-close:hover{color:var(--g);background:rgba(196,145,58,0.1);}
.modal-icon{font-size:64px;margin-bottom:25px;text-align:center;animation:floatIcon 3s infinite ease-in-out;}
@keyframes floatIcon{0%,100%{transform:translateY(0);}50%{transform:translateY(-10px);}}
.modal-title{font-family:'KyivType Sans Black',serif;font-size:32px;font-weight:700;color:var(--g);margin-bottom:20px;text-align:center;letter-spacing:1px;line-height:1.3;}
.modal-description{font-size:16px;line-height:1.9;color:var(--dm);margin-bottom:30px;text-align:center;border-bottom:1px solid var(--b);padding-bottom:25px;}
.modal-features{margin-bottom:30px;}
.modal-features h4{font-size:14px;font-weight:700;letter-spacing:3px;color:var(--g);text-transform:uppercase;margin-bottom:20px;text-align:center;}
.modal-features ul{list-style:none;padding:0;display:grid;grid-template-columns:repeat(2,1fr);gap:15px;}
.modal-features li{font-size:14px;color:var(--t);display:flex;align-items:center;gap:10px;background:rgba(196,145,58,0.05);padding:10px 15px;border:1px solid var(--b);transition:all 0.3s;}
.modal-features li:hover{border-color:var(--g);transform:translateY(-2px);background:rgba(196,145,58,0.1);}
.modal-features li::before{content:"✦";color:var(--g);font-size:14px;font-weight:bold;}
.modal-cta{text-align:center;margin-top:20px;}
.modal-cta button{background:var(--g);color:var(--k);border:none;padding:15px 40px;font-size:13px;font-weight:800;letter-spacing:3px;text-transform:uppercase;cursor:pointer;transition:all 0.3s;width:100%;min-height:44px;}
.modal-cta button:hover{background:var(--gl);transform:translateY(-2px);box-shadow:0 10px 25px rgba(196,145,58,0.3);}
.payment-modal-content{background:var(--d2);border:1px solid var(--g);max-width:800px;width:95%;max-height:90vh;overflow-y:auto;position:relative;transform:scale(0.9);transition:transform 0.4s ease;box-shadow:0 30px 60px rgba(0,0,0,0.5);}
.payment-modal-overlay.active .payment-modal-content{transform:scale(1);}
.payment-modal-body{padding:40px;}
.payment-plan-table{width:100%;border-collapse:collapse;margin-top:30px;}
.payment-plan-table th{text-align:left;padding:15px;background:rgba(196,145,58,0.1);color:var(--g);font-size:12px;font-weight:700;letter-spacing:2px;text-transform:uppercase;border-bottom:1px solid var(--g);}
.payment-plan-table td{padding:15px;border-bottom:1px solid var(--b);color:var(--dm);font-size:14px;}
.payment-plan-table tr:last-child td{border-bottom:none;background:rgba(196,145,58,0.05);color:var(--g);font-weight:600;}
.unit-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin:30px 0;}
.unit-card{background:var(--d3);border:1px solid var(--b);padding:20px;text-align:center;transition:all 0.3s;}
.unit-card:hover{border-color:var(--g);transform:translateY(-2px);}
.unit-type{font-family:'KyivType Sans Black',serif;font-size:18px;color:var(--w);margin-bottom:10px;}
.unit-price{color:var(--g);font-size:16px;font-weight:600;margin-bottom:8px;}
.unit-size{color:var(--dm);font-size:13px;}
.eoi-section{background:rgba(196,145,58,0.1);border:1px dashed var(--g);padding:20px;text-align:center;margin:30px 0;}
.eoi-amount{font-size:24px;color:var(--g);font-weight:700;margin:10px 0;}
.feature-list{list-style:none;padding:0;display:grid;grid-template-columns:repeat(2,1fr);gap:15px;margin:20px 0;}
.feature-list li{color:var(--dm);font-size:14px;display:flex;align-items:center;gap:10px;}
.feature-list li::before{content:"✓";color:var(--g);font-weight:bold;}
.contact-modal-content{background:var(--d2);border:1px solid var(--g);max-width:600px;width:95%;max-height:90vh;overflow-y:auto;position:relative;transform:scale(0.9);transition:transform 0.4s ease;box-shadow:0 30px 60px rgba(0,0,0,0.5);}
.contact-modal-overlay.active .contact-modal-content{transform:scale(1);}
.contact-modal-body{padding:40px;}
.map-link{display:inline-block;margin-top:10px;color:var(--g);text-decoration:none;font-size:14px;font-weight:600;transition:color 0.3s;}
.map-link:hover{color:var(--gl);text-decoration:underline;}
.investor-tag{background:rgba(196,145,58,0.15);color:var(--g);padding:8px 15px;border-radius:4px;font-size:14px;margin:15px 0;text-align:center;}
.fi.error{border-color:#ff6b6b !important;}
.fi.error:focus{border-color:#ff6b6b !important;box-shadow:0 0 0 1px #ff6b6b;}

/* ============================================
   RESPONSIVE - REDUCED SIZES
   ============================================ */
@media(max-width:1100px){
  .nav{padding:0 22px;}
  .nl,.ncta{display:none;}
  .mb{display:flex !important;}
  .logo{font-size:22px;letter-spacing:1.5px;gap:8px;}
  .nav-favicon{width:46px;height:46px;}
  .hc{padding:30px 28px 160px !important;}
  .sec{padding:60px 26px;}
  .agrid{grid-template-columns:1fr;}
  .aiw{height:400px;}
  .pg{grid-template-columns:repeat(2,1fr);}
  .svgrid{grid-template-columns:1fr 1fr;}
  .wgrid{grid-template-columns:1fr;}
  .cgrid{grid-template-columns:1fr;}
  .tgrid{grid-template-columns:1fr;}
  .fg{grid-template-columns:1fr 1fr;gap:30px;}
  .ftr{padding:46px 26px;}
  .hscrl{display:none;}
  .nbsec{padding:60px 26px;}
  .nbgrid{grid-template-columns:1fr 1fr;grid-template-rows:auto;}
  .nbcard:first-child{grid-row:span 1;}
  .hero{height:90vh;}
  .ht1,.ht2{font-size:clamp(28px,5vw,42px) !important;}
  .hey{font-size:9px;letter-spacing:4px;}
  .hpn{font-size:16px;}
  .hpl{font-size:9px;}
  .hbtns{margin-top:28px;gap:12px;}
  .bg,.bo{padding:12px 32px;font-size:12px;}
  .hdots{right:25px;}
  .hdot{height:14px;}
  .hdot.on{height:32px;}
}
  
@media(max-width:600px){
  .logo{font-size:17px;letter-spacing:0.5px;gap:6px;}
  .nav-favicon{width:36px;height:36px;}
  .nav{height:64px;padding:0 16px;}
  .pg,.svgrid,.fg{grid-template-columns:1fr;}
  .frow{grid-template-columns:1fr;}
  .nbgrid{grid-template-columns:1fr;}
  .hero{height:85vh;}
  .hc{padding:20px 20px 100px !important;}
  .ht1,.ht2{font-size:clamp(22px,6vw,28px) !important;line-height:1.2;}
  .hey{font-size:7px;letter-spacing:2px;gap:8px;margin-bottom:12px;}
  .hey::before{width:24px;}
  .hprop{margin-top:16px;}
  .hpn{font-size:12px;}
  .hpl{font-size:7px;letter-spacing:1.5px;}
  .hpl::before{width:12px;}
  .hbtns{margin-top:20px;flex-direction:column;width:100%;gap:10px;}
  .bg,.bo{width:100%;text-align:center;padding:10px 20px;font-size:10px;letter-spacing:1.5px;}
  .hdots{right:12px;gap:6px;}
  .hdot{width:1.5px;height:10px;}
  .hdot.on{height:24px;}
  .mm.open{background:rgba(8,8,8,.98);backdrop-filter:blur(5px);}
  .ml{font-size:28px;margin:8px 0;}
  .mc{top:20px;right:20px;font-size:20px;}
  .stit{font-size:clamp(24px,5vw,32px) !important;}
  .sdesc{font-size:12px;line-height:1.6;}
  .ey{font-size:8px;letter-spacing:2.5px;}
  .pg{gap:12px;}
  .pnm{font-size:16px;}
  .ppr{font-size:16px;}
  .pmeta{gap:10px;font-size:10px;}
  .modal-content{padding:35px 20px !important;width:95% !important;}
  .modal-title{font-size:24px !important;}
  .modal-features ul{grid-template-columns:1fr;}
  .unit-grid{grid-template-columns:1fr;gap:12px;}
  .feature-list{grid-template-columns:1fr;}
  .cform{padding:30px 20px;}
  .cft{font-size:24px;}
  .igrid{grid-template-columns:1fr;gap:10px;}
  .ib{padding:15px;}
  .fg{grid-template-columns:1fr;gap:30px;}
  .fbot{flex-direction:column;text-align:center;}
  .fbl{justify-content:center;}
}

@media(max-width:380px){
  .hc{padding:15px 16px 80px !important;}
  .ht1,.ht2{font-size:clamp(18px,5vw,22px) !important;}
  .hey{font-size:6px;letter-spacing:1.5px;}
  .bg,.bo{padding:8px 16px;font-size:9px;}
  .logo{font-size:14px;}
  .nav-favicon{width:30px;height:30px;}
}

@media(max-width:768px){
  button,.nbcard,.pc,.fl,.ml,.mb{cursor:pointer;-webkit-tap-highlight-color:transparent;}
  .bg,.bo,.fnx,.fbk{min-height:44px;}
  .fb button{padding:8px 16px;font-size:9px;}
}

.mb{transition:opacity 0.3s ease;}
.mb:hover{opacity:0.8;}
`;

function HeroImage({ image }) {
  return (
    <div style={{ position: "absolute", inset: 0 }}>
      <img src={image} alt="Dubai Luxury Property" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(62,61,61,0.3) 0%, rgba(0,0,0,0.7) 55%, rgba(0,0,0,0.95) 100%)" }} />
      {[...Array(20)].map((_, i) => (
        <div key={i} className="particle" style={{ top: `${Math.random() * 100}%`, left: `${Math.random() * 100}%`, animationDelay: `${Math.random() * 5}s`, animationDuration: `${5 + Math.random() * 5}s` }} />
      ))}
    </div>
  );
}

export default function App() {
  const [st, dispatch] = useReducer(reducer, initialState);
  const [scrolled, setScrolled] = useState(false);
  const [toast, setToast] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedPropertyForPayment, setSelectedPropertyForPayment] = useState(null);
  const [serviceModalOpen, setServiceModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const propertiesRef = useRef(null);

  const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", phone: "", message: "" });

  const EMAILJS_CONFIG = {
    SERVICE_ID: "service_somu38y",
    TEMPLATE_ID: "template_jvsn8tq",
    PUBLIC_KEY: "nbgiKhgvRrvIMJUfQ",
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      dispatch({ type: "SET_HERO_SLIDE", payload: (st.heroSlide + 1) % HERO_SLIDES.length });
    }, 2000);
    return () => clearInterval(t);
  }, [st.heroSlide]);

  useEffect(() => {
    emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
  }, []);

  useEffect(() => {
    return () => { document.body.style.overflow = "unset"; };
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName?.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName?.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[\+]?[1-9][\d]{0,15}$/.test(formData.phone.replace(/\D/g, ""))) {
      newErrors.phone = "Please enter a valid phone number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitContact = async () => {
    if (!validateForm()) {
      setToast("❌ Please fill in all required fields");
      setTimeout(() => setToast(""), 2800);
      return;
    }

    setIsSubmitting(true);

    try {
      const templateParams = {
        interest:    (st.contactInterest || "General Inquiry").trim(),
        from_name:   `${formData.firstName} ${formData.lastName}`.trim(),
        from_email:  formData.email.trim(),
        from_phone:  formData.phone.trim(),
        bedrooms:    (st.contactBeds && st.contactBeds.trim() !== "") ? st.contactBeds.trim() : "Not specified",
        message:     (formData.message && formData.message.trim() !== "") ? formData.message.trim() : "No additional message provided",
        date:        new Date().toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
      };

      const response = await emailjs.send(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_ID,
        templateParams,
        EMAILJS_CONFIG.PUBLIC_KEY
      );

      console.log("EmailJS success:", response);
      setSubmitted(true);
      setToast("✅ Thank you! Your request has been submitted successfully.");

      setTimeout(() => {
        setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
        setErrors({});
        dispatch({ type: "SET_CONTACT_INTEREST", payload: "" });
        dispatch({ type: "SET_CONTACT_BEDS", payload: "" });
        setTimeout(() => { closeContactModal(); setSubmitted(false); }, 2000);
      }, 1500);

    } catch (error) {
      console.error("EmailJS error:", error);

      const useMailto = window.confirm(
        "❌ Email service is temporarily unavailable.\n\n" +
        "Would you like to send your inquiry directly via your email app instead?\n\n" +
        "✓ Click OK to open your email app with all details pre-filled\n" +
        "✓ Click Cancel to close and try again later"
      );

      if (useMailto) {
        const subject = `Property Inquiry: ${st.contactInterest || "New Inquiry"} - ${formData.firstName} ${formData.lastName}`;
        const body = `
NEXT.FRONT PROPERTIES - NEW INQUIRY
====================================
Interest: ${st.contactInterest || "General Inquiry"}
Bedrooms: ${st.contactBeds || "Not specified"}

CONTACT DETAILS
------------------------------------
Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Phone: ${formData.phone}

MESSAGE
------------------------------------
${formData.message || "No message provided"}

Submitted: ${new Date().toLocaleString()}
        `.trim();
        window.location.href = `mailto:info@nextfrontproperties.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        setToast("📧 Opening your email app...");
      } else {
        setToast("❌ Submission cancelled. Please try again later.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWishlist = (id) => {
    const adding = !st.wishlist.includes(id);
    dispatch({ type: "TOGGLE_WISHLIST", payload: id });
    setToast(adding ? "❤️ Added to Wishlist" : "🤍 Removed from Wishlist");
    setTimeout(() => setToast(""), 2800);
  };

  const openServiceModal = (service) => { setSelectedService(service); setServiceModalOpen(true); document.body.style.overflow = "hidden"; };
  const closeServiceModal = () => { setServiceModalOpen(false); document.body.style.overflow = "unset"; setTimeout(() => setSelectedService(null), 400); };
  const openPaymentModal = (property) => { setSelectedPropertyForPayment(property); setPaymentModalOpen(true); document.body.style.overflow = "hidden"; };
  const closePaymentModal = () => { setPaymentModalOpen(false); document.body.style.overflow = "unset"; setTimeout(() => setSelectedPropertyForPayment(null), 400); };

  const openContactModal = (interest, propertyName = "") => {
    dispatch({ type: "SET_CONTACT_INTEREST", payload: propertyName ? `${interest} - ${propertyName}` : interest });
    dispatch({ type: "SET_CONTACT_STEP", payload: 3 });
    setContactModalOpen(true);
    document.body.style.overflow = "hidden";
    setSubmitted(false);
    setErrors({});
  };

  const closeContactModal = () => {
    setContactModalOpen(false);
    document.body.style.overflow = "unset";
    setTimeout(() => {
      if (!submitted) {
        setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
        setErrors({});
        dispatch({ type: "SET_CONTACT_STEP", payload: 1 });
        dispatch({ type: "SET_CONTACT_INTEREST", payload: "" });
        dispatch({ type: "SET_CONTACT_BEDS", payload: "" });
      }
    }, 400);
  };

  const scrollToSection = (ref) => {
    if (ref?.current) ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    if (st.menuOpen) dispatch({ type: "SET_MENU", payload: false });
  };

  const scrollToProperties = () => {
    if (propertiesRef.current) propertiesRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const scrollToPropertiesWithFilter = (filter) => {
    dispatch({ type: "SET_FILTER", payload: filter });
    setTimeout(() => scrollToProperties(), 100);
  };

  const filtered = PROPERTIES.filter((p) => {
    const fm = st.activeFilter === "ALL" ? true
      : st.activeFilter === "BUY" ? p.tag !== "RENT"
      : st.activeFilter === "RENT" ? p.tag === "RENT"
      : st.activeFilter === "LUXURY" ? p.tag === "LUXURY"
      : st.activeFilter === "OFF-PLAN" ? p.tag === "OFF-PLAN"
      : true;
    const qm = !st.searchQuery || p.name.toLowerCase().includes(st.searchQuery.toLowerCase()) || p.area.toLowerCase().includes(st.searchQuery.toLowerCase());
    return fm && qm;
  });

  const slide = HERO_SLIDES[st.heroSlide];

  return (
    <>
      <style>{S}</style>

      <nav className={`nav${scrolled ? " sc" : ""}`}>
        <div className="logo" onClick={() => scrollToSection(homeRef)}>
          <img src={NextFront_Favicon} alt="NextFront Logo" className="nav-favicon" />
          Next<em>.</em>Front
        </div>
        <div className="nl">
          <button className="ncta" onClick={() => window.open("mailto:info@nextfrontproperties.com", "_self")}>info@nextfrontproperties.com</button>
          <button className="ncta" onClick={() => (window.location.href = "tel:+918584826222")}>+91 85848 26222</button>
          <button className="ncta" onClick={() => openContactModal("Book Consultation")}>BOOK CONSULTATION</button>
        </div>
        <button className="mb" onClick={() => dispatch({ type: "SET_MENU", payload: true })}>
          <span /><span /><span />
        </button>
      </nav>

      <div className={`mm${st.menuOpen ? " open" : ""}`}>
        <button className="mc" onClick={() => dispatch({ type: "SET_MENU", payload: false })}>✕</button>
        <button className="ml" onClick={() => { dispatch({ type: "SET_MENU", payload: false }); openContactModal("Book Consultation"); }}>Book Consultation</button>
        <button className="ml" onClick={() => { dispatch({ type: "SET_MENU", payload: false }); scrollToProperties(); }}>Explore Properties</button>
        <button className="ml" onClick={() => { dispatch({ type: "SET_MENU", payload: false }); scrollToSection(contactRef); }}>Contact Us</button>
      </div>

      <section ref={homeRef} className="hero">
        {HERO_SLIDES.map((s, i) => (
          <div key={i} className={`hslide${i === st.heroSlide ? " on" : ""}`}>
            <HeroImage image={s.image} />
          </div>
        ))}
        <div className="hc">
          <div className="hey">Welcome To Next.Front Real Estate</div>
          <div className="ht1">{slide.title}</div>
          <div className="ht2">{slide.highlight}</div>
          <div className="hprop">
            <div className="hpn">{slide.sub}</div>
            <div className="hpl">{slide.loc}</div>
          </div>
          <div className="hbtns">
            <button className="bg" onClick={scrollToProperties}>EXPLORE PROPERTIES</button>
            <button className="bo" onClick={() => openContactModal("Consultation")}>BOOK CONSULTATION</button>
          </div>
        </div>
        <div className="hdots">
          {HERO_SLIDES.map((_, i) => (
            <button key={i} className={`hdot${i === st.heroSlide ? " on" : ""}`} onClick={() => dispatch({ type: "SET_HERO_SLIDE", payload: i })} />
          ))}
        </div>
        <div className="hscrl">Scroll</div>
      </section>

      <div className="tkw">
        <div className="tk">
          {[...Array(2)].flatMap(() => ["Luxury Villas","Penthouse Residences","Waterfront Properties","Off-Plan Projects","Premium Rentals","Investment Properties","Signature Homes","Ultra-Luxury Estates"]).map((t, i) => (
            <span key={i} className="tki">{t}</span>
          ))}
        </div>
      </div>

      <section ref={aboutRef} className="sec absec">
        <div className="si">
          <div className="agrid">
            <div className="aiw">
              <img src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?q=80&w=2070&auto=format&fit=crop" alt="Dubai Luxury Villa" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              <div className="aac" />
              <div className="abd">
                <div className="abn">3</div>
                <div className="abt">Years of Excellence</div>
              </div>
            </div>
            <div>
              <div className="ey">Who We Are</div>
              <h2 className="stit">REDEFINING LUXURY<br /><strong>SINCE 2023</strong></h2>
              <p className="sdesc" style={{ marginBottom: 18 }}>A bespoke experience is what you can look forward to with Next.Front Estates. We are specialists in luxury real estate with a property portfolio that only features Dubai's finest, most luxurious homes in prime locations across the city.</p>
              <p className="sdesc" style={{ marginBottom: 40 }}>As experienced professionals, we aspire to deliver a bespoke experience to every client. Through strategic partnerships we bring you value-added services including property management, mortgage assistance, and interior design.</p>
              <button className="bg" onClick={scrollToProperties}>DISCOVER MORE</button>
            </div>
          </div>
        </div>
      </section>

      <section className="nbsec">
        <div className="si">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16 }}>
            <div>
              <div className="ey">Prime Locations</div>
              <h2 className="stit">EXPLORE <strong>DUBAI'S FINEST</strong></h2>
            </div>
          </div>
          <div className="nbgrid">
            {NEIGHBORHOODS.map((n) => (
              <div key={n.name} className="nbcard" onClick={scrollToProperties}>
                <div className="nbbg-inner">
                  <img src={n.image} alt={n.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </div>
                <div className="nbover" />
                <div className="nbinfo">
                  <div className="nbname">{n.name}</div>
                  <div className="nbcount">{n.count}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section ref={propertiesRef} className="sec" style={{ background: "var(--k)" }}>
        <div className="si">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 40, flexWrap: "wrap", gap: 20 }}>
            <div>
              <div className="ey">Properties</div>
              <h2 className="stit">EXCLUSIVE <strong>LISTINGS</strong></h2>
            </div>
            <div className="fb">
              {["ALL", "BUY", "RENT", "LUXURY", "OFF-PLAN"].map((f) => (
                <button key={f} className={st.activeFilter === f ? "on" : ""} onClick={() => dispatch({ type: "SET_FILTER", payload: f })}>{f}</button>
              ))}
            </div>
          </div>
          {filtered.length > 0 ? (
            <div className="pg">
              {filtered.map((p) => (
                <div key={p.id} className="pc">
                  <div className="piw">
                    <div className="pcbg">
                      <img src={p.image} alt={p.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </div>
                    <div className={`pbadge ${p.badge === "NEW LAUNCH" ? "new-launch" : p.badge === "OFF-PLAN" ? "op" : ""}`}>{p.badge}</div>
                    <button className={`pheart${st.wishlist.includes(p.id) ? " lk" : ""}`} onClick={() => handleWishlist(p.id)}>
                      {st.wishlist.includes(p.id) ? "❤️" : "🤍"}
                    </button>
                  </div>
                  <div className="pinfo">
                    <div className="pty">{p.type} {p.tag === "RENT" ? "for Rent" : "for Sale"}</div>
                    <div className="pnm">{p.name}</div>
                    <div className="par">📍 {p.area}</div>
                    {p.developer && <div className="developer-badge">Developer: {p.developer}</div>}
                    <div className="pmeta">
                      <span>🛏 {p.beds} Bed</span>
                      <span>🚿 {p.baths} Bath</span>
                      <span>📐 {p.sqft} sq.ft</span>
                    </div>
                    <div className="ppr">{p.price}{p.eoi && <span className="eoi-badge">EOI: {p.eoi}</span>}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="emp">
              <div style={{ fontSize: 48, marginBottom: 14 }}>🏙️</div>
              <div style={{ fontSize: 14 }}>No properties found. Try adjusting your filters.</div>
            </div>
          )}
        </div>
      </section>

      <div className="lxb">
        <div className="lxbg">
          <img src="https://images.unsplash.com/photo-1518684079-3c830dcef090?q=80&w=1887&auto=format&fit=crop" alt="Dubai Luxury" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
        <div className="lxbov" />
        <div className="lxcont">
          <div className="lxtag">✦ Exclusive Dubai Properties ✦</div>
          <div className="lxtit">YOUR GATEWAY TO<br /><strong>ULTRA-LUXURY LIVING</strong></div>
          <div className="lxsub">Curated selection of the most prestigious addresses in Dubai</div>
          <div className="lxbtns">
            <button className="bg" onClick={scrollToProperties}>EXPLORE COLLECTION</button>
            <button className="bo" onClick={() => openContactModal("Expert Consultation")}>SPEAK TO AN EXPERT</button>
          </div>
        </div>
      </div>

      <section className="sec svcsec">
        <div className="si">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 52, alignItems: "end" }}>
            <div>
              <div className="ey">What We Do</div>
              <h2 className="stit">OUR <strong>SERVICES</strong></h2>
              <p className="sdesc">At Next.Front Estates, we are more than real estate agents; we are partners in your journey to find the perfect home, ensuring every step is as unique as the home itself.</p>
            </div>
          </div>
          <div className="svgrid">
            {SERVICES.map((s) => (
              <div key={s.title} className="svcard">
                <div className="svico">{s.icon}</div>
                <div className="svt">{s.title}</div>
                <div className="svd">{s.desc}</div>
                <button className="svl" onClick={() => openServiceModal(s)}>Learn More →</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sec whysec">
        <div className="si">
          <div style={{ maxWidth: 640 }}>
            <div className="ey">Why Choose Us</div>
            <h2 className="stit">UNPARALLELED <strong>EXPERTISE</strong></h2>
            <p className="sdesc">We combine industry knowledge with genuine dedication to every client relationship, delivering results that exceed expectations every single time.</p>
          </div>
          <div className="wgrid">
            {[
              { i: "🏆", t: "Reliability & Integrity", d: "We say what we deliver, and deliver what we say. Our commitment to honesty ensures you can always trust us to meet our every promise." },
              { i: "✨", t: "Personalized Excellence", d: "Our fresh approach combines passion and professionalism to create a personalized, bespoke experience that is unique to every single client." },
              { i: "⚡", t: "Efficiency & Value", d: "Discover your perfect prime property effortlessly with our dedicated team committed to delivering outstanding value and exceptional results." },
            ].map((w) => (
              <div key={w.t} className="wcard">
                <div className="wico">{w.i}</div>
                <div className="wt">{w.t}</div>
                <div className="wd">{w.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section ref={contactRef} className="sec ctrsec">
        <div className="si">
          <div className="cgrid">
            <div>
              <div className="ey">Get In Touch</div>
              <h2 className="stit">LET'S FIND YOUR<br /><strong>PERFECT PROPERTY</strong></h2>
              <p className="sdesc" style={{ marginBottom: 42 }}>Are you buying, selling, renting or want us to manage a property? Let us know your preferences and requirements. We're here to assist you.</p>
              {[
                { ico: "📍", lbl: "Office", val: "Next Front Properties 703, 7th Floor, NH12, Action Area IIE, Newtown, Kolkata West Bengal 700161" },
                { ico: "📞", lbl: "Phone", val: "+91 85848 26222" },
                { ico: "✉️", lbl: "Email", val: "info@nextfrontproperties.com" },
              ].map((c) => (
                <div key={c.lbl} className="ci">
                  <div className="cii">{c.ico}</div>
                  <div>
                    <div className="cil">{c.lbl}</div>
                    <div className="civ">{c.val}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="cform">
              <div className="cft">Express Your Interest</div>
              <div className="cfs">Click below to start your journey with us</div>
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <div className="igrid" style={{ marginBottom: "20px" }}>
                  {[{ ico: "🏠", lbl: "Buy/Sell" }, { ico: "🔑", lbl: "Rent" }, { ico: "📊", lbl: "Manage" }, { ico: "💰", lbl: "Mortgage" }].map((b) => (
                    <button key={b.lbl} className="ib" onClick={() => openContactModal(b.lbl)} style={{ textAlign: "center", padding: "20px" }}>
                      <span className="ii" style={{ fontSize: "32px", marginBottom: "10px" }}>{b.ico}</span>
                      <span className="il" style={{ fontSize: "12px" }}>{b.lbl}</span>
                    </button>
                  ))}
                </div>
                <p style={{ fontSize: "13px", color: "var(--dm)", marginTop: "20px" }}>✦ Our team will respond within 24 hours ✦</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec tsec">
        <div className="si">
          <div className="ey">Client Reviews</div>
          <h2 className="stit">WHAT OUR <strong>CLIENTS SAY</strong></h2>
          <div className="tgrid">
            {TESTIMONIALS.map((t) => (
              <div key={t.name} className="tc">
                <div className="tst">{"★".repeat(t.rating)}</div>
                <div className="tt">"{t.text}"</div>
                <div className="tau">
                  <div className="tav">{t.avatar}</div>
                  <div>
                    <div className="tn">{t.name}</div>
                    <div className="tr">Verified Client</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer className="ftr">
        <div className="fi2">
          <div className="fg">
            <div>
              <div className="fbn" onClick={() => scrollToSection(homeRef)} style={{ cursor: "pointer" }}>
                <img src={NextFront_Favicon} alt="NextFront Logo" className="footer-favicon" />
                Next<em>.</em>Front
              </div>
              <div className="ftg">Dubai Luxury Real Estate</div>
              <div className="fdc">Specialists in luxury real estate since 2023, offering Dubai's finest properties in prime locations with a bespoke client experience.</div>         
            </div>
            <div>
              <div className="fct">Quick Links</div>
              <span className="fl" onClick={() => scrollToSection(aboutRef)}>About Us</span>
              <span className="fl" onClick={() => scrollToPropertiesWithFilter("ALL")}>Ready Properties</span>
              <span className="fl" onClick={() => scrollToPropertiesWithFilter("OFF-PLAN")}>Off-Plan Resale</span>
              <span className="fl" onClick={() => scrollToPropertiesWithFilter("LUXURY")}>Luxury Collection</span>
              <span className="fl" onClick={() => scrollToPropertiesWithFilter("RENT")}>Premium Rentals</span>
              <span className="fl" onClick={() => scrollToSection(contactRef)}>Contact Us</span>
              <span className="fl">Careers</span>
            </div>
            <div>
              <div className="fct">New Launch</div>
              <span className="fl" onClick={() => { dispatch({ type: "SET_FILTER", payload: "OFF-PLAN" }); setTimeout(() => { const b = PROPERTIES.find((p) => p.id === 13); if (b) openPaymentModal(b); }, 100); }}>Belmont on the Park</span>
              <div style={{ fontSize: 12, color: "var(--dm)", marginTop: 10 }}>EOI: AED 20,000</div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div className="fct" style={{ textAlign: "center" }}>Our Services</div>
              {["Sales", "Sales", "Sales", "Property Management", "Investment Portfolio", "Design & Build"].map((title, i) => {
                const labels = ["Luxury Sales", "Residential Sales", "Residential Leasing", "Property Management", "Investment Portfolio", "Design & Build"];
                return <span key={i} className="fl" onClick={() => { const s = SERVICES.find((sv) => sv.title === title); if (s) openServiceModal(s); }}>{labels[i]}</span>;
              })}
            </div>
          </div>
          <div className="fbot">
            <div>© 2025 Next.Front Properties LLC. All Rights Reserved. <span className="orn">ORN: 546</span></div>
            <div className="fbl"><span>Privacy Policy</span><span>Terms & Conditions</span><span>FAQ</span></div>
          </div>
        </div>
      </footer>

      <div className={`modal-overlay${serviceModalOpen ? " active" : ""}`} onClick={closeServiceModal}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={closeServiceModal}>✕</button>
          {selectedService && (
            <>
              {selectedService.isNewLaunch && selectedService.property ? (
                <>
                  <div style={{ textAlign: "center", marginBottom: "20px" }}>
                    <div className="lxtag" style={{ justifyContent: "center", fontSize: "12px" }}>NEW LAUNCH | TOWN SQUARE</div>
                    <div className="modal-title" style={{ fontSize: "28px" }}>{selectedService.property.name}</div>
                    <div style={{ color: "var(--g)", fontSize: "16px", marginTop: "5px" }}>by {selectedService.property.developer}</div>
                  </div>
                  <div className="unit-grid" style={{ marginTop: "20px" }}>
                    {["1 Bedroom", "2 Bedroom", "3 Bedroom"].map((type) => (
                      <div key={type} className="unit-card">
                        <div className="unit-type">{type}</div>
                        <div className="unit-price">{selectedService.property.startingPrices[type]}</div>
                        <div className="unit-size">{selectedService.property.sizes[type]}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ textAlign: "center", margin: "25px 0 15px" }}>
                    <div style={{ fontSize: "18px", fontWeight: "700", color: "var(--g)" }}>💰 Flexible {selectedService.property.paymentPlan.type} Payment Plan</div>
                    <div style={{ fontSize: "14px", color: "var(--dm)", marginTop: "5px" }}>Installment 5% | Handover: {selectedService.property.paymentPlan.handover}</div>
                  </div>
                  <ul className="feature-list" style={{ marginTop: "15px" }}>
                    {selectedService.property.features.map((f, i) => <li key={i}>{f}</li>)}
                  </ul>
                  <div className="eoi-section" style={{ marginTop: "20px" }}>
                    <div style={{ fontSize: "14px", color: "var(--dm)" }}>Expression of Interest (EOI)</div>
                    <div className="eoi-amount">{selectedService.property.eoi}</div>
                    <div style={{ fontSize: "13px", color: "var(--dm)" }}>{selectedService.property.status}</div>
                    <div style={{ fontSize: "12px", color: "var(--g)", marginTop: "10px" }}>{selectedService.property.release}</div>
                  </div>
                  <div className="investor-tag">✨ Perfect option for both end-users & investors</div>
                  <a href={selectedService.property.googleMapsLink} target="_blank" rel="noopener noreferrer" className="map-link" style={{ textAlign: "center", display: "block", margin: "15px 0" }}>📍 VIEW LOCATION ON MAP</a>
                  <div className="modal-cta">
                    <button onClick={() => { closeServiceModal(); setTimeout(() => openContactModal("EOI - Belmont on the Park", selectedService.property.name), 100); }}>REGISTER YOUR INTEREST (EOI: {selectedService.property.eoi})</button>
                    <button onClick={() => { closeServiceModal(); setTimeout(() => { dispatch({ type: "SET_FILTER", payload: "OFF-PLAN" }); scrollToProperties(); }, 100); }} style={{ marginTop: "10px", background: "transparent", color: "var(--g)", border: "1px solid var(--g)" }}>VIEW MORE OFF-PLAN PROJECTS →</button>
                  </div>
                </>
              ) : (
                <>
                  <div className="modal-icon">{selectedService.icon}</div>
                  <div className="modal-title">{selectedService.title}</div>
                  <div className="modal-description">{selectedService.desc}</div>
                  <div className="modal-features">
                    <h4>What We Offer</h4>
                    <ul>{selectedService.features?.map((f, i) => <li key={i}>{f}</li>)}</ul>
                  </div>
                  <div className="modal-cta">
                    <button onClick={() => { closeServiceModal(); setTimeout(() => scrollToSection(contactRef), 100); }}>Discuss Your {selectedService.title} Needs</button>
                    <button onClick={() => { closeServiceModal(); setTimeout(() => scrollToProperties(), 100); }} style={{ marginTop: "10px", background: "transparent", color: "var(--g)", border: "1px solid var(--g)" }}>EXPLORE PROPERTIES →</button>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      <div className={`payment-modal-overlay${paymentModalOpen ? " active" : ""}`} onClick={closePaymentModal}>
        <div className="payment-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="payment-modal-close" onClick={closePaymentModal}>✕</button>
          <div className="payment-modal-body">
            {selectedPropertyForPayment && (
              <>
                <div style={{ textAlign: "center", marginBottom: "30px" }}>
                  <div className="lxtag" style={{ justifyContent: "center" }}>🚀 NEW LAUNCH</div>
                  <div className="cft" style={{ fontSize: "32px" }}>{selectedPropertyForPayment.name}</div>
                  <div style={{ color: "var(--g)", fontSize: "14px", marginTop: "5px" }}>by {selectedPropertyForPayment.developer} at {selectedPropertyForPayment.area}</div>
                </div>
                <div className="unit-grid">
                  {["1 Bedroom", "2 Bedroom", "3 Bedroom"].map((type) => (
                    <div key={type} className="unit-card">
                      <div className="unit-type">{type}</div>
                      <div className="unit-price">{selectedPropertyForPayment.startingPrices[type]}</div>
                      <div className="unit-size">{selectedPropertyForPayment.sizes[type]}</div>
                    </div>
                  ))}
                </div>
                <div style={{ textAlign: "center", marginBottom: "20px", color: "var(--g)", fontSize: "16px", fontWeight: 600 }}>💰 Flexible {selectedPropertyForPayment.paymentPlan.type} Payment Plan</div>
                <table className="payment-plan-table">
                  <thead><th>Installment</th><th>Percentage</th><th>Date</th></thead>
                  <tbody>
                    {selectedPropertyForPayment.paymentPlan.installments.map((inst, i) => (
                      <tr key={i}><td>{inst.phase}</td><td>{inst.percent}</td><td>{inst.date}</td></tr>
                    ))}
                  </tbody>
                </table>
                <div className="eoi-section">
                  <div style={{ fontSize: "14px", color: "var(--dm)" }}>Expression of Interest (EOI)</div>
                  <div className="eoi-amount">{selectedPropertyForPayment.eoi}</div>
                  <div style={{ fontSize: "13px", color: "var(--dm)" }}>{selectedPropertyForPayment.status}</div>
                  <div style={{ fontSize: "12px", color: "var(--g)", marginTop: "10px" }}>{selectedPropertyForPayment.release}</div>
                </div>
                <h4 style={{ margin: "30px 0 20px", color: "var(--g)" }}>✨ Key Features</h4>
                <ul className="feature-list">{selectedPropertyForPayment.features.map((f, i) => <li key={i}>{f}</li>)}</ul>
                <div style={{ display: "flex", gap: "15px", marginTop: "30px", flexDirection: "column" }}>
                  <button className="bg" style={{ width: "100%" }} onClick={() => { closePaymentModal(); setTimeout(() => openContactModal("EOI - Belmont on the Park", selectedPropertyForPayment.name), 100); }}>REGISTER YOUR INTEREST (EOI: {selectedPropertyForPayment.eoi})</button>
                  <button className="bo" style={{ width: "100%" }} onClick={closePaymentModal}>CLOSE</button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className={`contact-modal-overlay${contactModalOpen ? " active" : ""}`} onClick={closeContactModal}>
        <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="contact-modal-close" onClick={closeContactModal}>✕</button>
          <div className="contact-modal-body">
            <div className="cft" style={{ textAlign: "center", marginBottom: "10px" }}>
              {st.contactInterest.includes("Consultation") ? "Book a Consultation" : "Express Your Interest"}
            </div>
            <div className="cfs" style={{ textAlign: "center", marginBottom: "25px" }}>
              {st.contactInterest.includes("Consultation") ? "Schedule a call with our experts" : `Interested in ${st.contactInterest}`}
            </div>
            <div className="csteps" style={{ justifyContent: "center", marginBottom: "30px" }}>
              {[1, 2, 3].map((n) => <div key={n} className={`csd${st.contactStep >= n ? " on" : ""}`} />)}
            </div>

            {st.contactStep === 3 && !submitted && (
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: "var(--dm)", marginBottom: 13 }}>YOUR DETAILS</div>
                <div className="frow">
                  <div style={{ width: "100%" }}>
                    <input className={`fi ${errors.firstName ? "error" : ""}`} placeholder="First Name*" value={formData.firstName} onChange={(e) => setFormData({ ...formData, firstName: e.target.value })} />
                    {errors.firstName && <div style={{ color: "#ff6b6b", fontSize: "11px", marginTop: "-5px", marginBottom: "5px" }}>{errors.firstName}</div>}
                  </div>
                  <div style={{ width: "100%" }}>
                    <input className={`fi ${errors.lastName ? "error" : ""}`} placeholder="Last Name*" value={formData.lastName} onChange={(e) => setFormData({ ...formData, lastName: e.target.value })} />
                    {errors.lastName && <div style={{ color: "#ff6b6b", fontSize: "11px", marginTop: "-5px", marginBottom: "5px" }}>{errors.lastName}</div>}
                  </div>
                </div>
                <div>
                  <input className={`fi ${errors.email ? "error" : ""}`} placeholder="Email Address*" type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                  {errors.email && <div style={{ color: "#ff6b6b", fontSize: "11px", marginTop: "-5px", marginBottom: "5px" }}>{errors.email}</div>}
                </div>
                <div>
                  <input className={`fi ${errors.phone ? "error" : ""}`} placeholder="Phone Number*" type="tel" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                  {errors.phone && <div style={{ color: "#ff6b6b", fontSize: "11px", marginTop: "-5px", marginBottom: "5px" }}>{errors.phone}</div>}
                </div>
                <textarea className="fi" placeholder="Your message (optional)..." rows={3} style={{ resize: "vertical" }} value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} />
                <div style={{ background: "rgba(196,145,58,0.1)", border: "1px solid var(--b)", padding: "15px", marginBottom: "20px", fontSize: "13px", color: "var(--dm)" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                    <span>Interest:</span>
                    <span style={{ color: "var(--g)", fontWeight: 600 }}>{st.contactInterest}</span>
                  </div>
                  {st.contactBeds && (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Bedrooms:</span>
                      <span style={{ color: "var(--g)", fontWeight: 600 }}>{st.contactBeds}</span>
                    </div>
                  )}
                </div>
                <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                  <button
                    className="fnx"
                    style={{ flex: 1, opacity: isSubmitting ? 0.7 : 1 }}
                    onClick={handleSubmitContact}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "SENDING..." : "SUBMIT ENQUIRY"}
                  </button>
                  <button className="fbk" onClick={closeContactModal}>CANCEL</button>
                </div>
              </div>
            )}

            {st.contactStep === 3 && submitted && (
              <div style={{ textAlign: "center", padding: "38px 0" }}>
                <div style={{ fontSize: 38, marginBottom: 14 }}>✅</div>
                <div style={{ fontFamily: "'KyivType Sans Black',serif", fontSize: 24, color: "var(--w)", marginBottom: 8 }}>Thank You!</div>
                <div style={{ fontSize: 13, color: "var(--dm)", lineHeight: 1.7 }}>Our team will contact you within 24 hours to discuss your {st.contactInterest} requirements.</div>
                <button className="bg" style={{ marginTop: "25px", padding: "12px 25px", fontSize: "11px" }} onClick={() => {
                  setSubmitted(false);
                  dispatch({ type: "SET_CONTACT_STEP", payload: 1 });
                  dispatch({ type: "SET_CONTACT_INTEREST", payload: "" });
                  dispatch({ type: "SET_CONTACT_BEDS", payload: "" });
                  setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
                  setErrors({});
                  closeContactModal();
                }}>CLOSE</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {toast && <div className="tst2">{toast}</div>}
    </>
  );
}